module.exports = __webpack_public_path__ + "img/logo-dialog.405b5032.svg";